module.exports = __webpack_public_path__ + "static/media/thumbnail.712e40c8.jpg";